/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { ViewOnboardingModule } from '@coursera/event-pulse-types';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

type Props = React.PropsWithChildren<ViewOnboardingModule['onboardingModule']>;

function ViewOnboardingModuleVisibilityTracker(props: Props) {
  const { children, ...onboardingModule } = props;
  const ref: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker('view_onboarding_module', {
    onboardingModule,
  });
  return <div ref={ref}>{children}</div>;
}

export default ViewOnboardingModuleVisibilityTracker;
